/* The native theme remains responsible for selection, availability and checkout. */
(() => {
  'use strict';
  if (customElements.get('armadox-vareno-choice')) return;
  class ArmadoxVarenoChoice extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.product = this.closest('product-info');
      if (!this.product) return;
      try { this.variants = JSON.parse(this.querySelector('[data-vareno-variants]').textContent); } catch { return; }
      this.summary = this.querySelector('[data-vareno-summary]');
      this.advice = this.querySelector('[data-vareno-advice]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.product.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.render(event.target.value);
      }, options);
      document.addEventListener('variant:changed', event => {
        const id = event.detail?.variant?.id;
        if (id && String(this.product.querySelector('product-form input[name="id"]')?.value) === String(id)) this.render(id);
      }, options);
      this.render(this.dataset.selectedId);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    render(id) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.summary.replaceChildren();
      this.summary.hidden = !variant;
      if (variant) {
        this.summary.append(document.createTextNode(`Votre sélection : pointure ${variant.title}`));
        if (!variant.available) {
          const note = document.createElement('p');
          note.textContent = 'Cette pointure est actuellement indisponible.';
          this.summary.append(note);
          const sizes = this.variants.filter(v => v.available).map(v => v.title);
          if (sizes.length) {
            const alternatives = document.createElement('p');
            alternatives.textContent = `Pointures disponibles : ${sizes.join(', ')}. Choisissez uniquement votre pointure.`;
            this.summary.append(alternatives);
          }
        }
      }
      const link = new URL('https://api.whatsapp.com/send');
      link.searchParams.set('phone','212708778881');
      link.searchParams.set('text',`Bonjour ARMADOX, je souhaite un conseil pour VARENO Classic${variant ? ` — pointure ${variant.title}` : ''}. Ma pointure habituelle est : … ${this.dataset.productUrl}${variant ? `?variant=${variant.id}` : ''}`);
      this.advice.href = link.href;
    }
  }
  customElements.define('armadox-vareno-choice',ArmadoxVarenoChoice);
})();
